import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
/**
 * 地图投影装饰页
 * @date 2025-07-10
 */
import { getformListItemsdatas, setImgsize } from '@/utils/utils';
import { mapState, mapGetters, mapMutations } from 'vuex';
let _ = require('lodash');
import { transform } from 'ol/proj';
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
import uploadfile from '@/components/mapv2/uploadfile';
export default {
  name: 'mapdecoration',
  components: {
    uploadfile
  },
  meta: {
    title: ''
  },
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      rightShow: false,
      sourceform: {
        deptId: '186266',
        formId: '2184030',
        page: 1,
        limit: 100,
        searchStr: '',
        t: 'ab25462e5537dda01f7d25b07b7844e2cedc5ae94849013a92bd11cd2b9784dd'
      },
      // 素材库请求参数
      picList: [],
      detail: {}
    };
  },
  watch: {},
  computed: {
    ...mapGetters(['mapv2info'])
  },
  mounted() {},
  methods: {
    ...mapMutations(['SET_MAPDOMSTYLE']),
    open() {
      this.rightShow = true;
    },
    close() {
      this.rightShow = false;
    },
    /**
     * 地图投影装饰打开操作
     * @param {Object} item 选中数据
     * @date 2025-07-10
     */
    openHandle(item) {
      this.rightShow = true;
      console.log(`item`, item);
      this.detail = item;
      this.getData('地图装饰', item.title);
    },
    /**
     * 获取素材库表单数据
     * @param {String} type 素材类型
     * @param {String} bgtype 背景素材类型
     * @date 2025-07-10
     */
    getData(type, bgtype) {
      let that = this;
      let searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': 'material_type',
            'compt': 'selectbox',
            'express': '===',
            'val': [type]
          }]
        }]
      };
      if (bgtype !== undefined && bgtype !== '') {
        searchStr.filters.push({
          "model": 0,
          "filters": [{
            'alias': 'decoration_type',
            'compt': 'selectbox',
            'express': '===',
            'val': [bgtype]
          }]
        });
      }
      this.sourceform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.$api.singleadvanceSearchv2(this.sourceform).then(res => {
        if (res.totalRow > 0) {
          that.picList = res.dataList.map((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            return item;
          });
          console.log(`that.picList`, that.picList);
        }
      });
    },
    setImg(val) {
      return setImgsize(val, 74, 50);
    },
    /**
     * 素材拖操作
     * @date 2025-07-10
     */
    decorationDragStart(event, item) {
      event.dataTransfer.setData('text/plain', 0);
      console.log(`decorationDragStart`, item);
      this.$parent.pichandleDragStart(event, {
        type: 'decortaion',
        data: item
      });
    }
  }
};